/**
 * Service: viewState
 */
angular.module('acme.common.service.viewState', [])
.service('ViewStateService', [function() {

    return {

      stateMap: {},

      init: function() {},

      setState: function(key, state) {
        this.stateMap[key] = state;
      },

      getState: function(key) {
        var r = false;
        if (this.stateMap.hasOwnProperty(key)) {
          r = this.stateMap[key];
        }

        return r;
      },

      resetState: function(key) {
        this.stateMap[key] = false;
      },

      getStateProperty: function(key, property, defaultValue) {
        var r = defaultValue;
        if (this.stateMap.hasOwnProperty(key) && this.stateMap[key].hasOwnProperty(property)) {
          r = (this.stateMap[key])[property];
        }

        return r;
      },

      setStateProperty: function(key, property, value) {
        if (this.stateMap.hasOwnProperty(key)) {
          (this.stateMap[key])[property] = value;
        }
      }

    };

}]);